import ProductTransformer from './ProductTransformer';

export default class ProductOrderConfirmationTransformer extends ProductTransformer {
  static fetch(product, footnotes) {
    product = super.fetch(product, footnotes);

    const expression = new RegExp('InProgress', 'i');
    product = super.removeExpFromName(product, expression);

    return product;
  }

  static addFootnote(fn, product) {
    if (fn.name === 'footNoteConfirmationInProgress') {
      product.footnotes.push(fn.text);
    }
  }

  static parseFootnotes(product, footnotes) {
    ['productConfirmationInProgress', 'productConfirmationBeforeButtonsInProgress', 'productConfirmationAfterButtonsInProgress'].forEach(field => {
      product.texts[field] = footnotes.parse(product.texts[field]);
    });
  }
}
